import { AdsHelpHint } from "@/components/ads-assistant/AdsAssistantCollapsible";

export function AdsAssistantManualFormHeader({ canIngestPosts }: { canIngestPosts: boolean }) {
  return (
    <>
      <div className="flex flex-wrap items-baseline gap-2">
        <p className="text-xs font-medium text-gray-900 dark:text-gray-100">Manual ingestion</p>
        <AdsHelpHint label="Manual ingestion — field guide">
          Paste the <strong>exact caption or post text</strong> as it appears on Facebook or Google. Pick the{" "}
          <strong>platform</strong> and <strong>time posted</strong>. External id is optional unless mirroring a real
          post id. <strong>Creative description</strong> explains what the image shows (or should). Categories and
          template link the row to your library. Submit runs stub analysis and policy checks.
        </AdsHelpHint>
      </div>
      {!canIngestPosts ? (
        <p className="rounded-lg border border-amber-200 bg-amber-50/90 px-2 py-1.5 text-[11px] text-amber-950 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-100">
          Your account can use the Ads library and quality labels, but <strong>logging new posts</strong> needs one
          of: sales, marketing, trainer, admin, owner, dev, or platform. Ask an admin to add a role if you should
          submit ads.
        </p>
      ) : null}
    </>
  );
}
